<template>
  <modal
    v-slot="{ data }"
    name="confirmation"
    modal-style="compact"
    :display-header-title="false"
  >
    <confirmation :data="data" />
  </modal>
</template>


<script>
  import Confirmation from './confirmation/index.vue';

  export default {
    name: 'ConfirmationModal',

    components: {
      Confirmation
    }
  };
</script>
